import { Link } from 'react-router-dom';
import { Group } from '@/components/ui/layout';
import { Button } from '@/components/ui/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { ActionIcon, useMantineColorScheme } from '@mantine/core';
import { IconSun, IconMoon } from '@tabler/icons-react';
import { usePreferencesStore } from '@/stores';

export interface AuthHeaderProps {
  showThemeToggle?: boolean;
  showBackButton?: boolean;
  backTo?: string;
}

export function AuthHeader({
  showThemeToggle = true,
  showBackButton = false,
  backTo = '/auth/login'
}: AuthHeaderProps) {
  const { colorScheme, setColorScheme } = useMantineColorScheme();
  const setColorSchemeMode = usePreferencesStore((state) => state.setColorSchemeMode);
  const isDark = colorScheme === 'dark';

  const handleThemeToggle = () => {
    const nextScheme = isDark ? 'light' : 'dark';
    setColorScheme(nextScheme);
    setColorSchemeMode(nextScheme);
  };

  return (
    <Group
      justify="space-between"
      p="lg"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
      }}
    >
      {/* Logo or Back Button */}
      <Group gap="md">
        {showBackButton ? (
          <Button
            component={Link}
            to={backTo}
            variant="subtle"
            size="sm"
            leftSection={<IconArrowLeft size={16} />}
          >
            Back
          </Button>
        ) : (
          <img
            src="/logo.png"
            alt="CCMS"
            style={{
              height: '40px',
              cursor: 'pointer',
              objectFit: 'contain'
            }}
          />
        )}
      </Group>

      {/* Theme Toggle */}
      {showThemeToggle && (
        <ActionIcon
          variant="subtle"
          size="lg"
          onClick={handleThemeToggle}
          title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        >
          {isDark ? <IconSun size={20} /> : <IconMoon size={20} />}
        </ActionIcon>
      )}
    </Group>
  );
}

export default AuthHeader;
